<div class="px-3">
  <div class="rem-text-default mb-4">
    <div class="flex align-items-end">
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-chart-bar font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Reporting Dashboard</div>
        <div class="text-right mt-2">View and analyze charts of remitter data</div>
      </div>
    </div>
  </div>

  <p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel header="Payments"></p-tabPanel>
    <p-tabPanel header="Communications"></p-tabPanel>
    <p-tabPanel header="Imports"></p-tabPanel>
  </p-tabView>

  <div [ngClass]="{'visibility-hidden': activeIndex !== 0}"> 
      <payments-dashboard 
        [creditors]="creditors!"
        [timezones]="timezones"
      />
  </div>      

  <div [ngClass]="{'visibility-hidden': activeIndex !== 1}" > 
       <communications-dashboard 
          [creditors]="creditors!"
          [timezones]="timezones"
       />
  </div>


  <div [ngClass]="{'visibility-hidden': activeIndex !== 2}" > 
        <import-ingestions-dashboard
            [creditors]="creditors!"
            [timezones]="timezones"
        />
  </div>
</div>